import PropTypes from 'prop-types';

export default {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  toggleRoutes: PropTypes.func,
  openMealsSelection: PropTypes.func,
  closeMealsSelection: PropTypes.func,
  editOpened: PropTypes.bool,
  selectedPassenger: PropTypes.string,
  classes: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/containers/meals/desktop/MealsDesktopProps.js